/* src/app/shared/components/survey/survey.component.css */
/*# sourceMappingURL=survey.component-LVOS5X5B.css.map */
